<div class="blog-widget-wrap">

    <!-- blog-widget start -->
    <div class="widget-blog blog-widget mt-30">
        <h5 class="title">Recent POST</h5>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/secure-your-financial-transactions"><img src="assets/images/blog/secure-your-financial-transactions.jpeg" alt="Secure your Financial Transactions with Advanced SIM & Device Binding Solution"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/secure-your-financial-transactions">
                    Secure your Finan...</a></h6>
                </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/sim_binding_solution_protect_sim_swap_frauds"><img src="assets/images/blog/sim-binding-solution-protect-sim-swap-frauds.jpeg" alt="SSIM Binding solution protect SIM Swap Frauds"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/sim_binding_solution_protect_sim_swap_frauds">
                    How AppBind SIM ...</a></h6>
                </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/sim-and-device-binding-mitigating"><img src="assets/images/blog/sim_device_binding_mitigating.webp" alt="SIM & Device Binding: Mitigating Identity Theft & Frauds for 
                    Banking & Financial Apps
                    "></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/sim-and-device-binding-mitigating">
                    Financial and Mobile B...</a></h6>
                </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/safeguard-against-banking-and-financial-frauds-through-phishing-links"><img src="assets/images/blog/appbind_blog.webp" alt="Safeguard Against Banking & Financial Frauds Through Phishing Links"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/safeguard-against-banking-and-financial-frauds-through-phishing-links">
                    In today’s digitally dr...</a></h6>
                </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/safeguard-against-banking-and-financial-frauds-through-phishing-links"><img src="assets/images/blog/deviceandsimbinding.jpeg" alt="Device and SIM Binding"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/deviceandsimbinding">
                    Comply with National Pay...</a></h6>
                </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/protecting-sensitive-mobile-apps-on-rooted-device"><img src="assets/images/blog/rooted_devices.webp" alt="rooted_devices"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/protecting-sensitive-mobile-apps-on-rooted-device">
                    Protecting Sensitive M...</a></h6>
                    <!-- <span>1 hour ago</span> -->
                </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/rasp-in-era-of-devsecops"><img src="assets/images/blog/devsecops.webp" alt="devsecops"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/rasp-in-era-of-devsecops">
                    Runtime Applicat...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/risk_and_impacts_of_accessibility_permission"><img src="assets/images/blog/accessibility_permission.webp" alt="accessibility_permission"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/risk_and_impacts_of_accessibility_permission">
                    The Risk and Impact of Acce...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/reverse-engineering-on-android-mobile-aplication"><img src="assets/images/blog/reverse_eng.webp" alt="reverse_eng"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/reverse-engineering-on-android-mobile-aplication">Reverse Engineering on...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/zerotrustdeviceandsimbindingsolution"><img src="assets/images/blog/appbindblog.webp" alt="appbindblog"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/zerotrustdeviceandsimbindingsolution">Ensure a Safe and Secure ...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/protect-your-sensitive-mobile-apps"><img src="assets/images/blog/protect_your_sensitive.webp" alt="protect_your_sensitive"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/protect-your-sensitive-mobile-apps">Protect Your Sensitive Mobi...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/four-ways-to-improve-the-mobile-application"><img src="assets/images/blog/4ways_to_improve_mobile_application.webp" alt="4ways_to_improve_mobile_application"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/four-ways-to-improve-the-mobile-application">5 Ways To Improve The M...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/six-important-tips-for-mobile-data"><img src="assets/images/blog/six_important_tips.webp" alt="six_important_tips"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/six-important-tips-for-mobile-data">6 Important Tips to Secure...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/mobile-payments-application-security-controls"><img src="assets/images/blog/mobile-payments-application-security-control.png" alt="mobile-payments-application-security-control"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/mobile-payments-application-security-controls">Mobile Payments App...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/enhancing-mobile-app-security-through-rasp"><img src="assets/images/blog/protect-mobile-app-usecured-wifi.webp" alt="protect-mobile-app-usecured-wifi"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/protect-mobile-apps-from-unsecured-wifi">Protect Your Mobile...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <!-- widget-blog-inner start -->
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/protect-your-corporate-mobile-app-from-reverse-engineering"><img src="assets/images/blog/protect-your-corporate-mobile-app-from-reverse-engineering.webp" alt="protect-your-corporate-mobile-app-from-reverse-engineering"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/protect-your-corporate-mobile-app-from-reverse-engineering">Protect Your Corporate App...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <!-- widget-blog-inner end -->
        <!-- widget-blog-inner start -->
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/how-mobile-app-spoofing-impacts-business"><img src="assets/images/blog/how-mobile-app-spoofing-impacts-business.webp" alt="how-mobile-app-spoofing-impacts-business"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/how-mobile-app-spoofing-impacts-business">How Mobile App Spoof...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <!-- widget-blog-inner end -->
        <!-- widget-blog-inner start -->
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/five-ways-to-enhance-your-android-phone-security"><img src="assets/images/blog/five-ways-to-enhance-your-android-phone-security.webp" alt="five-ways-to-enhance-your-android-phone-security"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/five-ways-to-enhance-your-android-phone-security">Five Ways to Enhan...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <!-- widget-blog-inner end -->

        <!-- widget-blog-inner start -->
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/smartphone-antivirus-need-of-the-hour"><img src="assets/images/blog/smartphone-antivirus-need-of-the-hour.webp" alt="smartphone-antivirus-need-of-the-hour"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/smartphone-antivirus-need-of-the-hour">Smartphone Antivirus: Nee...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <!-- widget-blog-inner end -->
        <!-- widget-blog-inner start -->
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/seven-must-have-apps-on-your-smartphone"><img src="assets/images/blog/seven-must-have-apps-on-your-smartphone.webp" alt="seven-must-have-apps-on-your-smartphone"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/seven-must-have-apps-on-your-smartphone">Seven Must Have App...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <!-- widget-blog-inner end -->
        <!-- widget-blog-inner start -->
        <div class="widget-blog-inner">
            <div class="widget-blog-image">
                <a routerLink="/enhancing-mobile-app-security-through-rasp"><img src="assets/images/blog/mobile-app-security-rasp.webp" alt="mobile-app-security-rasp"></a>
            </div>
            <div class="widget-blog-content text-left">
                <h6><a routerLink="/enhancing-mobile-app-security-through-rasp">Enhancing Mobile A...</a></h6>
                <!-- <span>1 hour ago</span> -->
            </div>
        </div>
        <!-- widget-blog-inner end -->
    </div>
    <!-- blog-widget end -->

    <!-- blog-widget start -->
    <!-- <div class="blog-widget mt-30">
            <h5 class="title">Archives</h5>
            <ul>  
                <li><a href="blog-details.html">December  <span>(11)</span></a></li>
                <li><a href="blog-details.html">October <span>(13)</span></a></li>
                <li><a href="blog-details.html">August <span>(6)</span></a></li>
                <li><a href="blog-details.html">January <span>(51)</span></a></li>
            </ul>
        </div> -->
    <!-- blog-widget end -->

    <!-- blog-widget start -->
    <!-- <div class="blog-widget mt-30">
            <h5 class="title">Hot Tags</h5>
            <div class="widget-tag sidebar-tag">
                <a href="#">Women</a>
                <a href="#">Bags</a>
                <a href="#">Man</a>
                <a href="#">Hot</a>
                <a href="#">fashion</a>
                <a href="#">digital</a>
            </div>
        </div> -->
    <!-- blog-widget end -->
</div>
<!-- blog-widget-wrap end -->
<!-- </div> -->